import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { httpsCallable } from 'firebase/functions';
import { useEffect, useState } from 'react';
import { functions } from '../../../core/services/firebase';
import { getProfileImageURL } from '../../../core/services/storage';

// プロフィールキャッシュ（セッション中は再取得しない）
const profileCache = new Map();

async function fetchPublicProfile(uid) {
  if (profileCache.has(uid)) return profileCache.get(uid);

  const getPublicProfilesFn = httpsCallable(functions, 'getPublicProfiles');
  const { data } = await getPublicProfilesFn({ uids: [uid] });
  const profile = data[uid] || null;
  profileCache.set(uid, profile);
  return profile;
}

export function TimelineCard({ certificate }) {
  const [nickname, setNickname] = useState('');
  const [profileImage, setProfileImage] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const profile = await fetchPublicProfile(certificate.uid);
        if (cancelled) return;
        if (profile) {
          setNickname(profile.nickname || certificate.uid.substring(0, 5));
          if (profile.profileImage) {
            const url = await getProfileImageURL(profile.profileImage);
            if (!cancelled) setProfileImage(url);
          }
        } else {
          setNickname(certificate.uid.substring(0, 5));
        }
      } catch (err) {
        console.error('Failed to fetch user info:', err);
        setNickname(certificate.uid.substring(0, 5));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [certificate.uid]);

  const eventDate = certificate.eventDate?.toDate?.() ? certificate.eventDate.toDate().toLocaleDateString() : '';

  return (
    <Card
      sx={{
        mb: 2,
        position: 'relative',
        overflow: 'visible',
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 12,
          bottom: 12,
          width: 3,
          borderRadius: 2,
          background: 'linear-gradient(135deg, #8a2be2, #FFD700)',
          opacity: 0,
          transition: 'opacity 0.25s ease',
        },
        '&:hover::before': {
          opacity: 1,
        },
      }}
    >
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
          <Avatar
            src={profileImage}
            sx={{
              width: 36,
              height: 36,
              mr: 1.5,
              border: '2px solid',
              borderColor: 'rgba(255, 56, 92, 0.15)',
            }}
          />
          <Box>
            <Typography variant="body2" fontWeight="bold" sx={{ lineHeight: 1.2 }}>
              {nickname}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
              {eventDate}
            </Typography>
          </Box>
        </Box>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 0.5 }}>
          {certificate.eventName}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Typography variant="body2" color="text.secondary">
            グロス: {certificate.time}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            ネット: {certificate.netTime}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
